class MainCallback {
    constructor() {

        this.form = document.querySelector('.gf-maincallback');
        if (!this.form) return false;

        this.submitBtn = this.form.querySelector('input[type=submit]');
        this.callBackBtn = document.querySelectorAll('[data-target="#callback"]');
        this.timeNotice = this.form.querySelector('.gf-maincallback__notice');

        this.dateSelect = this.form.querySelector('.gf-maincallback__date select');

        this.timeSelect = this.form.querySelector('.gf-maincallback__time select');
        this.timeField = this.form.querySelector('.gf-maincallback__time');
        this.timeOptions = this.timeField.querySelectorAll('option');

        this.timezoneSelect = this.form.querySelector('.gf-maincallback__timezone select');
        this.timezoneField = this.form.querySelector('.gf-maincallback__timezone');


        this.events();
    }

    // Events
    events() {
        this.callBackBtn.forEach(btn => btn.addEventListener('click', this.updateCallTime.bind(this)))
        gform.addAction('gform_input_change', this.updateCallTime.bind(this), 10, 3);
    }

    updateCallTime() {
        // Получить время клиента
        const today = new Date();
        const currentHour = today.getHours();
        // Проверить если больше 21:00, то скрыть "сегодня"
        this.toggleTodayOption(currentHour);
        // Когда вам будет удобнее?*
        const selectedDateValue = this.dateSelect.value.toLowerCase();

        // Если сегодня
        if (selectedDateValue === 'сегодня' || selectedDateValue === 'today') {
            // Скрыть/показать время Во сколько позвонить?*
            this.todayLogic(currentHour);
        }

        // Если завтра
        if (selectedDateValue === 'завтра' || selectedDateValue === 'tomorrow') {
            this.tomorrowLogic();
        }
    }

    tomorrowLogic() {
        // Включить кнопку submit
        this.submitBtn.removeAttribute('disabled')
        // Показать поле Во сколько позвонить?*
        this.timeField.classList.remove('gf-maincallback__time--hidden');
        // показать все значение
        this.timeOptions.forEach(option => {
            option.removeAttribute('disabled');
        });
        this.timeOptions[0].setAttribute('selected', 'selected');
        // скрыть уведовление
        this.timeNotice.classList.remove('gf-maincallback__notice--active')
    }

    todayLogic(hour) {
        const halfHourMs = 1800000; // Зазор в полчаса в милисеундах
        const selectedTimezone = this.timezoneSelect.value;
        let diffTime = selectedTimezone.replace(/UTC/gi, '');
        let operand = diffTime.substring(0, 1);
        diffTime = diffTime.replace(operand, '').split('_');
        const diffHours = diffTime[0] ? diffTime[0] : 0;
        const diffMinutes = diffTime[1] ? diffTime[1] : 0;
        const diffSeconds = (diffHours * 60 * 60) + (diffMinutes * 60)
        const mSeconds = diffSeconds * 1000;
        let currentTime = +Date.now() + halfHourMs;
        if (selectedTimezone !== 'UTCp3') {
            diffTime = operand === 'p' ? currentTime + mSeconds : currentTime - mSeconds;
            currentTime = new Date(diffTime);
        } else {
            currentTime = new Date(currentTime);
        }
        this.toggleTimeOptions(currentTime.getHours())
    }

    toggleTimeOptions(hour) {
        const timeOptions = this.timeField.querySelectorAll('option');

        if (hour < 9 || hour >= 21) {
            this.timeField.classList.add('gf-maincallback__time--hidden');
            this.timeNotice.classList.add('gf-maincallback__notice--active');
            this.submitBtn.setAttribute('disabled', 'disabled');
            return false;
        } else {
            this.timeField.classList.remove('gf-maincallback__time--hidden');
            this.timeNotice.classList.remove('gf-maincallback__notice--active');
            this.submitBtn.removeAttribute('disabled');
        }

        timeOptions.forEach(option => {
            const [start, end] = option.value.split('_');
            if (hour >= end) {
                option.setAttribute('disabled', 'disabled');
                if (option.index[0]) {
                    option.setAttribute('selected', 'selected')
                } else {
                    option.removeAttribute('selected');
                }
            } else {
                option.removeAttribute('disabled')
                if (hour >= start && hour <= end) {
                    option.setAttribute('selected', 'selected')
                }
            }
        })
    }

    toggleTodayOption(hour) {
        const options = this.dateSelect.querySelectorAll('option');
        options.forEach(option => {
            if (hour >= 21) {
                if (option.value !== 'Завтра' || option.value !== 'Tomorrow') {
                    option.setAttribute('disabled', 'disabled');
                    option.removeAttribute('enabled');
                    option.removeAttribute('selected');
                } else {
                    option.setAttribute('selected', 'selected');
                }

                this.timeField.style.display = 'list-item';
                this.timeSelect.removeAttribute('disabled');

                this.timezoneField.style.display = 'list-item';
                this.timezoneSelect.removeAttribute('disabled');

            } else if (hour < 9) {
                if (option.value === 'Сейчас' || option.value === 'Now') {
                    option.setAttribute('disabled', 'disabled');
                    option.removeAttribute('enabled');
                    option.removeAttribute('selected');
                } else {
                    if (option.index[0]) {
                        option.setAttribute('selected', 'selected')
                    } else {
                        option.removeAttribute('selected');
                    }
                }

                this.timeField.style.display = 'list-item';
                this.timeSelect.removeAttribute('disabled');

                this.timezoneField.style.display = 'list-item';
                this.timezoneSelect.removeAttribute('disabled');
            } else {
                option.setAttribute('enabled', 'enabled');
                option.removeAttribute('disabled');
                if (option.index[0]) {
                    option.setAttribute('selected', 'selected')
                } else {
                    option.removeAttribute('selected');
                }
            }
        })
    }
}

export default MainCallback;
